import { motion } from "framer-motion";
import { Rocket, ArrowRight, CheckCircle2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Editable } from "@/components/builder/Editable";
import { useContent } from "@/context/ContentContext";

const PERKS = [
  { key: "t1", text: "Attivazione in pochi minuti" },
  { key: "t2", text: "Nessuna carta di credito richiesta" },
  { key: "t3", text: "Tutte le funzioni AI incluse" },
];

export const FreeTrial = () => {
  const { ctaClick } = useContent();
  return (
    <section id="prova-gratis" data-testid="free-trial" className="bg-white">
      <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6 lg:px-8 lg:py-20">
        <div className="surface-navy relative overflow-hidden rounded-[2rem] px-6 py-14 text-center sm:px-12">
          <div className="absolute inset-0 bg-grid-faint opacity-[0.10]" aria-hidden="true" />
          <div className="pointer-events-none absolute -right-16 -top-16 h-56 w-56 rounded-full bg-cyan-400/20 blur-3xl" aria-hidden="true" />
          <div className="relative mx-auto max-w-2xl">
            <p className="mb-4 inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-cyan-200 backdrop-blur">
              <Sparkles className="h-3.5 w-3.5" /> <Editable path="trial.eyebrow">Inizia oggi</Editable>
            </p>
            <Editable as="h2" path="trial.title" className="block font-display text-3xl font-extrabold text-white sm:text-4xl lg:text-5xl">
              Prova Sedio gratis, senza impegno.
            </Editable>
            <Editable as="p" path="trial.desc" className="mx-auto mt-4 block max-w-xl text-base leading-7 text-slate-200">
              Crea il tuo account e scopri subito come l'AI gestisce comunicazione, segnalazioni e pratiche del condominio. Inizi in pochi minuti, direttamente dal browser.
            </Editable>

            <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-sm text-slate-200">
              {PERKS.map((p, i) => (
                <motion.span key={p.key} initial={{ opacity: 0, y: 8 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.35, delay: i * 0.08 }} className="inline-flex items-center gap-2">
                  <CheckCircle2 className="h-4 w-4 text-cyan-300" /> <Editable path={`trial.${p.key}`}>{p.text}</Editable>
                </motion.span>
              ))}
            </div>

            <div className="mt-9 flex justify-center">
              <Button data-testid="freetrial-cta-button" size="lg" onClick={ctaClick("trial.cta.link", "https://app.sedio.it")} className="btn-cta h-12 gap-2 px-8 text-base">
                <Rocket className="h-4 w-4" /> <Editable path="trial.cta">Provalo gratis ora</Editable> <ArrowRight className="h-4 w-4" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
